export default {
  methods: {
    addToCart(product) {
      const productName = product.productInfo.product.productName
      this.$store.dispatch('cart/add', product)
        .then(() => {
          const msg = '商品:「' + productName + '」，数量：「' + product.num +'」已添加到购物车。';
          this.addCartSuccess(msg);
        })
        .catch((error) => {
          this.addCartFail(error.message);
        })
    },
    addCartSuccess(msg) {
      const h = this.$createElement;
      this.$msgbox({
        title: '购物车提示',
        message: h('p', null, [
          h('span', null, msg),
        ]),
        showCancelButton: true,
        confirmButtonText: '购物车结算',
        cancelButtonText: '继续购物',
      }).then(action => {
        this.$router.push({name:'cart-index'});
      });
    },
    addCartFail(msg) {
      this.$alert(msg, '购物车提示', {
        confirmButtonText: '确定'
      });
    }
  }
}
